import type { Components } from "@mui/material";
import type { Theme } from "@mui/material/styles";

declare module "@mui/material/Button" {
  interface AucompletePropsVariantOverrides {
    groupBy: true;
  }
}

function isTheme(theme: unknown): theme is Theme {
  return typeof theme === "object" && theme !== null && "typography" in theme;
}

export const MuiAutocomplete: Components["MuiAutocomplete"] = {
  styleOverrides: {
    endAdornment: {
      right: "8px",
      "& button": {
        marginLeft: "2px",
      },
    },
    groupLabel: ({ theme }) => {
      if (isTheme(theme)) {
        return {
          position: "sticky",
          padding: "8px 16px 4px",
          backgroundColor: "white",
          lineHeight: "17px",
          ...theme.typography.body1SemiBold,
          color: "#202020",
        };
      }
      return {};
    },
    option: {
      minHeight: "0 !important",
    },
    listbox: {
      padding: "8px 0px 16px",
      "& li": {
        minHeight: "0 !important",
      },
    },
    groupUl: {
      padding: "0px 0px 0px",
      "& li": {
        padding: "4px 24px 4px !important",
      },
    },
  },
};
